
import { configureStore } from '@reduxjs/toolkit';
import chatReducer from './chatSlice';
import dreamworldReducer from './dreamworldSlice';
import discoverReducer from './discoverSlice';
import tagReducer from './tagSlice';
import profileReducer from './profileSlice';
import followingReducer from './followingSlice';
import editingChatsReducer from './editingChatsSlice';
import effectsReducer from './effectsSlice';

export const store = configureStore({
  reducer: {
    chat: chatReducer,
    dreamworld: dreamworldReducer,
    discover: discoverReducer,
    tag: tagReducer,
    profile: profileReducer,
    following: followingReducer,
    editingChats: editingChatsReducer,
    effects: effectsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
